/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrganizationRelationshipRequestDto
 */
export interface UpdateOrganizationRelationshipRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRelationshipRequestDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRelationshipRequestDto
     */
    relationType: UpdateOrganizationRelationshipRequestDtoRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRelationshipRequestDto
     */
    orgId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRelationshipRequestDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRelationshipRequestDto
     */
    notes?: string;
}


/**
 * @export
 */
export const UpdateOrganizationRelationshipRequestDtoRelationTypeEnum = {
    Client: 'CLIENT',
    Landlord: 'LANDLORD',
    Oem: 'OEM'
} as const;
export type UpdateOrganizationRelationshipRequestDtoRelationTypeEnum = typeof UpdateOrganizationRelationshipRequestDtoRelationTypeEnum[keyof typeof UpdateOrganizationRelationshipRequestDtoRelationTypeEnum];


/**
 * Check if a given object implements the UpdateOrganizationRelationshipRequestDto interface.
 */
export function instanceOfUpdateOrganizationRelationshipRequestDto(value: object): value is UpdateOrganizationRelationshipRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('relationType' in value) || value['relationType'] === undefined) return false;
    if (!('orgId' in value) || value['orgId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    return true;
}

export function UpdateOrganizationRelationshipRequestDtoFromJSON(json: any): UpdateOrganizationRelationshipRequestDto {
    return UpdateOrganizationRelationshipRequestDtoFromJSONTyped(json, false);
}

export function UpdateOrganizationRelationshipRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationRelationshipRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'relationType': json['relationType'],
        'orgId': json['orgId'],
        'partnerOrgId': json['partnerOrgId'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateOrganizationRelationshipRequestDtoToJSON(json: any): UpdateOrganizationRelationshipRequestDto {
    return UpdateOrganizationRelationshipRequestDtoToJSONTyped(json, false);
}

export function UpdateOrganizationRelationshipRequestDtoToJSONTyped(value?: UpdateOrganizationRelationshipRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'relationType': value['relationType'],
        'orgId': value['orgId'],
        'partnerOrgId': value['partnerOrgId'],
        'notes': value['notes'],
    };
}

